import React from 'react'

function TextGame() {
  return (
    <div>
      <code >print("Hello")</code>
    </div>
  )
}

export default TextGame
